import React, { useState } from 'react';
import truncate from 'lodash/truncate';

import ListResource from './ListResource.jsx';
import ListCompSelect from './ListCompSelect.jsx';

const api = 'api/quiz/scores/questions';

const formatLabel = (v) => {
  if (!v || v === 'single-select') return '單選';
  if (v === 'multi-select') return '多選';
  if (v === 'ordering') return '排序';
  if (v === 'matching') return '配對';
  if (v === 'image-dragdrop') return '圖片拖放';
  if (v === 'sentence-completion') return '詩詞重組';
  if (v === 'idiom-fill') return '成語填空';
  return v || '';
};

const ListScores = () => {
  const [compFilter, setCompFilter] = useState({});

  return (
    <ListResource
      {...{
        // searchable: true,
        api,
        sort: { 'question.qSetCode': 1 },
        filter: { ...compFilter },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: 'export',
        },
        ctrls: [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
            questionSet
          />,
        ],
        cols: [
          {
            key: 'question.qSetCode',
            children: 'Subject',
            sortable: true,
          },
          {
            key: 'question.refCode',
            children: 'Code',
            sortable: true,
          },
          {
            key: 'question.question',
            children: 'Question',
            getter: (v) => truncate(v, 15),
          },
          {
            key: 'question.format',
            children: 'Format',
            sortable: true,
            getter: (v) => formatLabel(v),
          },
          {
            key: 'answered',
            children: (
              <span title="Number of times the question has been drawn randomly">
                Picked *
              </span>
            ),
            sortable: true,
          },
          {
            key: 'isCorrect',
            children: 'Correct',
            sortable: true,
          },
          {
            key: 'correctPct',
            children: 'Correct %',
            sortable: true,
            getter: (v) => (v !== 'na'
              ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'
            ),
          },
        ],
      }}
    />
  );
};

export default ListScores;
